const convertToBlob = (files) => {
    // files (Array of File obejcts): the files to be converted to blob
    // new images, not yet on cloudinary
    // receiving images from the input form in binary format
    // -> convert to blob so that can display them via createObjectURL in image previews
    if (!files || files.length <= 0) {
      return [];
    }
    const blobs = files.map((file) => {
      return new Blob([file], { type: file.type });
    });
    return blobs;
  };

  export default convertToBlob;